import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

class ETInspectionOverviewForm extends Form {
	state = {
		data: {
			inspectionStd: '',
			ndeTechnique: '',
			equipment: '',
			probe: '',
			scanningLevel: '',
			remarks: '',
			serialNo: '',
			calibrationBlk: '',
			procedureNo: '',
			probeFrequency: '',
			acceptanceCriteria: '',
			sensitivity: '',
			calibrated: new Date(),
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		inspectionStd: Joi.string().min(3).required().label('Inspection Standard'),
		procedureNo: Joi.string().min(3).required().label('Procedure Number'),
		ndeTechnique: Joi.string().min(3).required().label('NDE Technique'),
		equipment: Joi.string().min(3).required().label('Equipment'),
		probe: Joi.string().min(3).required().label('Probe'),
		probeFrequency: Joi.string().min(3).required().label('Probe Frequency'),
		acceptanceCriteria: Joi.string()
			.min(3)
			.required()
			.label('Acceptance Criteria'),
		calibrationBlk: Joi.string().min(3).required().label('Calibration BLK'),
		sensitivity: Joi.string().min(3).required().label('Sensitivity'),
		serialNo: Joi.string().min(3).required().label('Serial Number'),
		scanningLevel: Joi.string().min(3).required().label('Scanning Level'),
		calibrated: Joi.date().less('now').required().label('Calibration Date'),
		remarks: Joi.string().required().label('Remarks'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({
			data: {
				inspectionStd: '',
				ndeTechnique: '',
				equipment: '',
				probe: '',
				scanningLevel: '',
				remarks: '',
				serialNo: '',
				calibrationBlk: '',
				procedureNo: '',
				probeFrequency: '',
				acceptanceCriteria: '',
				sensitivity: '',
				calibrated: new Date(),
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'inspectionStd',
							label: 'Inspection Standard',
							placeholder: 'Enter Inspection Standard',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'procedureNo',
							label: 'Procedure Number',
							placeholder: 'Enter Procedure Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'ndeTechnique',
							label: 'NDE Technique',
							placeholder: 'Enter NDE Technique',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'equipment',
							label: 'Equipment',
							placeholder: 'e.g. Enter Equipment',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderDatePicker({
							name: 'calibrated',
							label: 'Calibration Date',
							placeholderText: 'Select Calibration Date',
							maxDate: new Date(),
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'probe',
							label: 'Probe',
							placeholder: 'Enter Probe',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'calibrationBlk',
							label: 'Calibration Blk',
							placeholder: 'Enter Calibration Blk',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'probeFrequency',
							label: 'Probe Frequency',
							placeholder: 'Enter Probe Frequency',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							name: 'acceptanceCriteria',
							type: 'text',
							label: 'Acceptance Criteria',
							placeholder: 'Enter Acceptance Criteria',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'sensitivity',
							label: 'Sensitivity',
							placeholder: 'Enter Sensitivity',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'serialNo',
							label: 'Serial Number',
							placeholder: 'Enter Serial Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'scanningLevel',
							label: 'Scanning Level',
							placeholder: 'Enter Scanning Level',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				{this.renderTextArea({
					name: 'remarks',
					label: 'Remarks',
					placeholder: 'Enter Remarks',
					rows: '6',
				})}

				{this.renderButton('Submit Overview')}
			</form>
		);
	}
}

export default ETInspectionOverviewForm;
